import { render, staticRenderFns } from "./MeuUsuarioDialogSenha.vue?vue&type=template&id=20f6e6e2"
import script from "./MeuUsuarioDialogSenha.vue?vue&type=script&lang=js"
export * from "./MeuUsuarioDialogSenha.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports